import React, { useContext } from 'react';
import { ActionClient, AssistantPropertiesClient, BrainSimulationClient, BusinessClient, BusinessPropertiesClient, CalendarOAuthClient, CalendarTokenClient, CalendarTokenClientV2, ContactClient, ConversationsClient, DigestClient, EnrichedActionClient, EnrichedContextClient, EnrichedMeetingTypeClient, GeneratedTextClient, GuidelinesClient, HighlightsClient, IndividualTaskClient, LinkedAccountClient, MeetingTypeClient, MetasiteClient, MetricsClient, ParticipantsClient, RecipientClient, RecommendationsClient, RecurringScheduleClient, RoutinesClient, SentryLogger, ServicesFacadeClient, SimulationPresetClient, SiteMediaFilesClient, TasksClient } from '@wix/ai-scheduling-assistant-common-lib/http';
export const ClientsContext = /*#__PURE__*/React.createContext(null);
export const ClientsContextProvider = _ref => {
  let {
    httpClient,
    children
  } = _ref;
  const logger = new SentryLogger();
  const assistantPropertiesClient = new AssistantPropertiesClient(httpClient, logger);
  const generatedTextClient = new GeneratedTextClient(httpClient, logger);
  const meetingTypeClient = new MeetingTypeClient(httpClient, logger);
  const businessClient = new BusinessClient(httpClient, logger);
  const linkAccountClient = new LinkedAccountClient(httpClient, logger);
  const tasksClient = new TasksClient(httpClient, logger);
  const actionsClient = new ActionClient(httpClient, logger);
  const recurringScheduleClient = new RecurringScheduleClient(httpClient, logger);
  const servicesFacadeClient = new ServicesFacadeClient(httpClient, logger);
  const enrichedActionClient = new EnrichedActionClient(httpClient, logger);
  const contactClient = new ContactClient(httpClient, logger);
  const calendarOAuthClient = new CalendarOAuthClient(httpClient, logger);
  const siteMediaFilesClient = new SiteMediaFilesClient(httpClient, logger);
  const highlightsClient = new HighlightsClient(httpClient, logger);
  const guidelinesClient = new GuidelinesClient(httpClient, logger);
  const calendarTokenClient = new CalendarTokenClient(httpClient, logger);
  const calendarTokenClientV2 = new CalendarTokenClientV2(httpClient, logger);
  const businessPropertiesClient = new BusinessPropertiesClient(httpClient, logger);
  const enrichedMeetingTypeClient = new EnrichedMeetingTypeClient(httpClient, logger);
  const participantClient = new ParticipantsClient(httpClient, logger);
  const recommendationsClient = new RecommendationsClient(httpClient, logger);
  const metricsClient = new MetricsClient(httpClient, logger);
  const conversationsClient = new ConversationsClient(httpClient, logger);
  const digestClient = new DigestClient(httpClient, logger);
  const recipientClient = new RecipientClient(httpClient, logger);
  const routinesClient = new RoutinesClient(httpClient, logger);
  const metasiteClient = new MetasiteClient(httpClient, logger);
  const brainSimulationClient = new BrainSimulationClient(httpClient, logger);
  const enrichedContextClient = new EnrichedContextClient(httpClient, logger);
  const individualTaskClient = new IndividualTaskClient(httpClient, logger);
  const simulationPresetClient = new SimulationPresetClient(httpClient, logger);
  const context = {
    httpClient,
    assistantPropertiesClient,
    generatedTextClient,
    meetingTypeClient,
    businessClient,
    linkAccountClient,
    tasksClient,
    actionsClient,
    servicesFacadeClient,
    enrichedActionClient,
    recurringScheduleClient,
    contactClient,
    calendarOAuthClient,
    siteMediaFilesClient,
    highlightsClient,
    guidelinesClient,
    calendarTokenClient,
    calendarTokenClientV2,
    businessPropertiesClient,
    enrichedMeetingTypeClient,
    participantClient,
    recommendationsClient,
    metricsClient,
    conversationsClient,
    digestClient,
    recipientClient,
    routinesClient,
    metasiteClient,
    brainSimulationClient,
    enrichedContextClient,
    individualTaskClient,
    simulationPresetClient
  };
  return /*#__PURE__*/React.createElement(ClientsContext.Provider, {
    value: context
  }, children);
};
export function useClientsContext() {
  const context = useContext(ClientsContext);
  if (!context) {
    throw new Error('ClientsContext must be used within an ClientsContextProvider');
  }
  return context;
}
//# sourceMappingURL=ClientsContext.js.map